export default __webpack_public_path__ + "static/media/page1.fa54bdf1.png";